import { supabase } from "@/integrations/supabase/client";
import { Store } from "@/models/storeModel";

export const updateStore = async (
  id: string,
  updates: Partial<Store>
): Promise<Store | null> => {
  try {
    // Map industry type to valid enum value if it exists
    const validIndustryType = updates.industryType
      ? (updates.industryType as
          | "restaurant"
          | "cafe"
          | "bar"
          | "nightclub"
          | "hotel"
          | "spa"
          | "salon"
          | "tattoo"
          | "massage_therapy"
          | "catering"
          | "retail"
          | "fitness"
          | "beauty"
          | "healthcare"
          | "education"
          | "other")
      : undefined;

    const { data: store, error } = await supabase
      .from("stores")
      .update({
        name: updates.name,
        address: updates.address,
        phone: updates.phone,
        email: updates.email,
        is_active: updates.is_active,
        is_b2b: updates.isB2B,
        legal_name: updates.legalName,
        tax_id: updates.taxId,
        business_type: updates.businessType,
        registration_number: updates.registrationNumber,
        industry_type: validIndustryType,
        payment_terms: updates.paymentTerms,
        company_phone: updates.companyPhone,
        company_address: updates.companyAddress,
        logo: updates.logo,
        advanced_inventory_tracking: updates.advanced_inventory_tracking,
        street: updates.street,
        street_number: updates.street_number,
        latitude: updates.latitude,
        longitude: updates.longitude,
        order_radius_meters: updates.order_radius_meters,
        request_payment_mode: updates.request_payment_mode,
        balance: updates.balance,
        geofencing_enabled: updates.geofencing_enabled,
        slug: updates.slug,
      })
      .eq("id", id)
      .select()
      .single();

    if (error) {
      return null;
    }

    return {
      ...store,
      id: store.id,
      name: store.name,
      address: store.address,
      phone: store.phone,
      email: store.email,
      is_active: store.is_active,
      created_at: store.created_at,
      updated_at: store.updated_at,
      slug: store.slug,
      business_hours: store.business_hours
        ? JSON.parse(store.business_hours as string)
        : undefined,
    };
  } catch (error) {
    console.error("Error in updateStore:", error);
    return null;
  }
};
